

import { Chip, Tooltip, Typography } from "@mui/material"
import dayjs from "dayjs"

const isoDateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/
export function formatValue(val) {
  if (val === null || val === undefined) return ""
  if (typeof val === "string" && isoDateTimeRegex.test(val)) {
    return dayjs(val).format("YYYY-MM-DD HH:mm:ss")
  }
  return val
}

export const EXCLUDE_KEYS = new Set([
  "ModDte", "ModAccId", "ModAccNm", "LogAccId", "LogAccNm", "LogFlg", "LogRmk", "id", "No", "_diff"
])
const logFlgConfig = {
  A: { label: "เพิ่ม",  color: "success" },
  E: { label: "แก้ไข", color: "warning" },
  D: { label: "ลบ",    color: "error"   },
}

export const columns  = (colNm) =>[
    {
      field: "No",
      headerName: "No.",
      width: 50,
      align: "center",
    },
    {
      field: "ModDte",
      headerName: "วันเวลา",
      width: 140,
      valueFormatter: ({ value }) => value ? dayjs(value).format("DD/MM/YY HH:mm:ss") : "-",
    },
    {
      field: "LogFlg",
      headerName: "การกระทำ",
      width: 90,
      align: "center",
      renderCell: ({ value }) => {
        const cfg = logFlgConfig[value] || { label: value, color: "default" }
        return <Chip label={cfg.label} color={cfg.color} size="small" />
      }
    },
    {
      field: "ModAccNm",
      headerName: "ผู้ทำรายการ",
      width: 220,
    },
    {
      field: "_diff",
      headerName: "ข้อมูลที่เปลี่ยนแปลง",
      flex: 1,
      renderCell: ({ row }) => {
        const diff = row._diff || {}
        if (Object.keys(diff).length === 0) return "N/A"
        return (
          <Tooltip
            title={<pre style={{ fontSize: 11 }}>{JSON.stringify(diff, null, 2)}</pre>}
            componentsProps={{ tooltip: { sx: { maxWidth: 500, maxHeight: 400, overflow: "auto" } } }}>
            <Typography variant="body2" sx={{ cursor: "pointer", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {Object.entries(diff).map(([k, v]) => `${k}: ${v}`).join("  ,  ")}
            </Typography>
          </Tooltip>
        )
      }
    },
  ]
